module.exports = __webpack_public_path__ + "_assets/img/user.9a1c3a1c.svg";